export default {"src":"/_next/static/media/reset.a1810df4.svg","height":24,"width":24};